export const EV_CREATIVE_IDS = {
  EV_MODULE: 'edm-entry-ev-insights',
  HYBRID_EV_MODULE: 'Plug-In Hybrid Insights',
  RANGE_AND_BATTERY: 'battery-range-and-charging',
  CHARGING_AT_HOME: 'charging',
  TAX_CREDITS_AND_REBATES: 'tax-credits',
  WARRANTY: 'warranty',
  COST_TO_DRIVE: 'cost-to-drive',
  RANGE_MODULE: 'edm-entry-range',
  TREEHOUSE_PROMOTION: 'treehouse-promotion',
};

export const TOOLTIPS_IDS = {
  ESTIMATED_ID: 'estimated-tooltip',
  BATTERY_ID: 'battery-score-tooltip',
  WARRANTY_ID: 'ev-insight-battery-warranty',
  RANGE_MAP: 'range-map',
  RANGE_BATTERY: 'range-battery',
  RANGE_ESTIMATED: 'range-estimated',
  ABOUT_MAP: 'about-map',
  CHARGIN_PORT_INSIGHT: 'charging-port-insight',
  HOME_CHARGING: 'home-charging',
};

export const TOOLTIPS_VALUES = {
  ESTIMATED_VALUE: 'Est. Range',
  BATTERY_VALUE: 'Battery Range Score',
  WARRANTY_VALUE: 'EV Battery Warranty',
};

export const TOOLTIPS_TEXT = {
  ESTIMATED_TEXT:
    'Estimated Range is Recurrent Motors’ prediction of the distance that this vehicle can travel on a full charge. This value is based on the age, mileage and location of this vehicle, and the battery pack of this vehicle model and of vehicles in similar model classes. Actual range will vary depending on the condition of this vehicle’s battery pack, how you drive, driving conditions and other factors.',
  BATTERY_TEXT:
    'Range Score is based on this vehicle’s current Estimated Range and Recurrent Motors’ comparison of that Estimated Range with its estimated range when new.',
};

export const TOOLTIPS_DATA = {
  [TOOLTIPS_IDS.ESTIMATED_ID]: {
    creativeId: EV_CREATIVE_IDS.RANGE_AND_BATTERY,
    value: TOOLTIPS_VALUES.ESTIMATED_VALUE,
  },
  [TOOLTIPS_IDS.BATTERY_ID]: {
    creativeId: EV_CREATIVE_IDS.RANGE_AND_BATTERY,
    value: TOOLTIPS_VALUES.BATTERY_VALUE,
  },
  [TOOLTIPS_IDS.WARRANTY_ID]: {
    creativeId: EV_CREATIVE_IDS.WARRANTY,
    value: TOOLTIPS_VALUES.WARRANTY_VALUE,
  },
  [TOOLTIPS_IDS.RANGE_MAP]: { creativeId: EV_CREATIVE_IDS.RANGE_MODULE, value: 'Range Map' },
  [TOOLTIPS_IDS.RANGE_BATTERY]: { creativeId: EV_CREATIVE_IDS.RANGE_MODULE, value: 'Battery Life' },
  [TOOLTIPS_IDS.RANGE_ESTIMATED]: { creativeId: EV_CREATIVE_IDS.RANGE_MODULE, value: 'Estimated Range' },
  [TOOLTIPS_IDS.ABOUT_MAP]: { creativeId: EV_CREATIVE_IDS.RANGE_AND_BATTERY, value: 'About the range map' },
  [TOOLTIPS_IDS.CHARGIN_PORT_INSIGHT]: { creativeId: EV_CREATIVE_IDS.RANGE_AND_BATTERY, value: 'Charging Port' },
  [TOOLTIPS_IDS.HOME_CHARGING]: { creativeId: EV_CREATIVE_IDS.RANGE_AND_BATTERY, value: 'Home Charging' },
};

export const RANGE_AND_BATTERY_IDS = {
  BATTERY_CAPACITY_ID: 'battery-capacity',
  EPA_RANGE_ID_USED: 'epa-range-used',
  EPA_RANGE_ID_NEW: 'epa-range-new',
};

export const RANGE_AND_BATTERY_VALUES = {
  DEFAULT_VALUE: 'Unavailable',
  EPA_RANGE_VALUE_NEW: 'EPA Range',
  EPA_RANGE_VALUE_USED: 'Original EPA Range',
  BATTERY_CAPACITY: 'Battery Capacity',
};

export const DEFAULT_VALUE = 'Unavailable';

export const UNLIMITED = 'unlimited';

export const BATTERY_WARRANTY_DATA = {
  WARRANTY_HEADER_NEW: 'Battery Warranty',
  WARRANTY_HEADER_USED: 'Battery Warranty Remaining*',
  WARRANTY_TOOLTIP:
    'The federal government requires that EV batteries be warrantied for a minimum of 8 years or 100,000 miles. The EV battery warranty includes replacement if your battery capacity drops below a certain percentage of the original capacity.',
  WARRANTY_DISCLAIMER:
    '*Warranty remaining values are estimated based on the vehicle year and mileage provided by the dealer. Confirm exact warranty coverage with the dealer and the manufacturer before purchasing.',
  HYBRID_WARRANTY_TOOLTIP:
    'Hybrid batteries are federally mandated to carry at least 8 years or 100,000 miles of warranty coverage from the manufacturer. Batteries that lose capacity more rapidly than expected should be eligible for replacement under warranty. Coverage of additional hybrid components beyond the battery itself will vary by automaker.',
};
